 
import { CLEAR_ONE_PARAMETER } from '~~/constants/googleTagManager';
import type { EventSourceLocation } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const buildClearSingleFiltersParameter = ({
  filterName,
  filterValue,
  categoryPath,
  categoryName,
  listingType,
}: {
  filterName: string,
  filterValue: string | number,
  categoryPath: string,
  categoryName: string,
  listingType: EventSourceLocation
}) => ({
  event: CLEAR_ONE_PARAMETER,
  event_info: {
    filter_name: filterName,
    filter_value: filterValue,
    category_path: categoryPath,
    category_name: categoryName,
    listing_type: listingType,
  },
});
